import pluralize from '../../util/pluralize';

export const getLinkedInstitutionRowSubtitle = ({
    sharedCount,
    privateCount,
}: {
    sharedCount: number;
    privateCount: number;
}) => {
    return `${sharedCount} shared ${pluralize('account', sharedCount, false)} | ${privateCount} private ${pluralize('account', privateCount, false)}`;
};
